import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ConfigService {
  private config;

  constructor(private http: HttpClient) {
  }


  async load(url) {
      let res = await this.http.get(url).toPromise();
      this.config = res;
  }

  getConfiguration() {
    return this.config;
  }

}